import { render, staticRenderFns } from "./other.vue?vue&type=template&id=56219d06&scoped=true&"
import script from "./other.vue?vue&type=script&lang=js&"
export * from "./other.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56219d06",
  null
  
)

export default component.exports